'use strict';

import { Entity } from '../Entity';

export class StaffSignatureEmail extends Entity {
  protected signatureId;

  protected staff;

  protected signature;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.signatureId = data.signatureId;

    this.staff = data.staff;

    this.signature = data.signature;
  }

  public getSignatureId() {
    return this.signatureId;
  }

  public setSignatureId(signatureId) {
    this.signatureId = signatureId;

    return this;
  }

  public getStaff() {
    return this.staff;
  }

  public setStaff(staff) {
    this.staff = staff;

    return this;
  }

  public getSignature() {
    return this.signature;
  }

  public setSignature(signature) {
    this.signature = signature;

    return this;
  }
}
